import './importantQuotes.scss';

export default function(streaming) {
    if (!streaming) {
        console.warn('No streaming given. Existing');
        return null;
    }

    document.querySelectorAll('.md-ticker-holder').forEach(item => {
        const ids = item.dataset.socket;
        streaming.subscribeTickerIDS(ids);
    })
}
